import { useEffect, useMemo } from 'react';

import { useInfiniteQuery } from '@tanstack/react-query';

import { toInfiniteQuery } from '../data/pagination.ts';

export { getPageParamFromUrl } from '../data/pagination.ts';

export const useAllPagesQuery = <TData,>(query: Parameters<typeof toInfiniteQuery<TData>>[0]) => {
    const infiniteQuery = useInfiniteQuery(toInfiniteQuery(query));

    const { fetchNextPage, hasNextPage, isFetching, isFetchNextPageError } = infiniteQuery;

    useEffect(() => {
        if (query.enabled !== false && hasNextPage && !isFetching && !isFetchNextPageError) {
            void fetchNextPage();
        }
    }, [query.enabled, hasNextPage, isFetching, isFetchNextPageError, fetchNextPage]);

    const data = useMemo(() => infiniteQuery.data?.pages.flatMap((page) => page.results) ?? [], [infiniteQuery.data]);
    return { ...infiniteQuery, data };
};

export default useAllPagesQuery;
